import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import adduserscreen from './img/burpcow/adduserscreen.png';
import playscreen from './img/burpcow/genericplayscreentablet.png';
import helpscreen from './img/burpcow/helpscreentablet.png';
import openingscreen from './img/burpcow/openingscreenshottablet.png';
import appstorebadge from './img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';



export const BurpCow = ({}) => {



	return (
		<div className="container-fluid appdesc">
<div className="row padrow">
 <div className="col-md-8 col-lg-8">
			 <h2>Burp the Cow</h2>
 </div>
 <div className="col-md-4 col-lg-2">
 <div className="badgecontainer">
		 <a href='https://apps.apple.com/app/id1519098740'><img src={ appstorebadge } alt="Get in on App Store Badge" className="applebadge img-responsive d-block mx-auto badge"/></a>
</div>
 </div>
 <div className="col-md-4 col-lg-2">

 </div>

 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12 centervideo">
  <iframe width="560" height="315" src="https://www.youtube.com/embed/qwJTddw8M_8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
 </div>
 </div>

	<div className="row padrow">
	<div className="col-md-12 col-lg-12 youtube">

	<a href='https://www.youtube.com/channel/UC4eN-brmGnxMLAYw3N5tA_g?view_as=subscriber?sub_confirmation=1'><b>Subscribe to YouTube Channel!</b>

	</a>
 </div>
 </div>
<div className="row padrow">
<div className="col-md-12 col-lg-12">
			This is a simple fun game designed to help children learn to take turns, as taught to some in speech therapy.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={ playscreen } alt="playing screen showing game in action" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
 <div className="row padrow">
<div className="col-md-12 col-lg-12">
			Generic player one or player two icons can be used or user photos and/or names can be added for better association.  Information or pictures are NEVER SHARED by Helen's Software Company.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src= {adduserscreen } alt="Add user screen" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>

<div className="row padrow">
			 <div className="col-md-12 col-lg-12">
			 Users can play with one turn each, or random turns each for older children.  Instructions provided with app as follows.
 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
       <img src= {helpscreen } alt="help screen" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
 </div>

 </div>


			 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
 Please let us know if you experience any issues are have any suggstions at our feedback form <Link to="/feedback" >
 here
 </Link>.</div>
 </div>


</div>

			)


}
